import React, { Component } from 'react'
import { inject, observer } from 'mobx-react'
import PerfectScrollbar from 'react-perfect-scrollbar'

import {NotificationContainer, NotificationManager} from 'react-notifications'

import Sidebar from '../../components/Sidebar'
import MapInfo from '../../components/MapInfo'
import Map from '../../components/Map'

import SearchCarModal from '../../components/Order/SearchCarModal'
import NotFoundModal from '../../components/Order/NotFoundModal'
import CarFoundModal from '../../components/Order/CarFoundModal'
import CarArrivedModal from '../../components/Order/CarArrivedModal'
import CarOnWayModal from '../../components/Order/CarOnWayModal'

import 'react-perfect-scrollbar/dist/css/styles.css';

@observer
class LoginPage extends Component {
  state = {
    hide: false,
  }

  sidebarToggel = () => {
      this.setState({
          hide: !this.state.hide
      })
  }

  componentDidUpdate(prevProps){
    if(this.props.errorMsg.length > 0 && this.props.errorMsg !== prevProps.errorMsg){
      NotificationManager.error(this.props.errorMsg, 'Ошибка', 5000)
    }

    if(this.props.succesMsg.length > 0 && this.props.succesMsg !== prevProps.succesMsg){
      NotificationManager.success(this.props.succesMsg, 'Успешно', 5000)
    }
  }

  render() {
    return (<>
    <div className="row work-region">
      <div className={this.state.hide ? "col sidebar sidebar-hide" : "col sidebar"}>
        <PerfectScrollbar>
          <Sidebar />
        </PerfectScrollbar>        
      </div>
      <div className="col map-region" style={{width: "calc(100vw-350px)"}}>
        <div className="btn-toggle" onClick={this.sidebarToggel}>
          <div className="btn-toggle__icon"></div>
        </div>
        <div className="maps">
          <Map />
        </div>
        <MapInfo />
        {this.props.orderStage ? (
          <div className="order-modal-container">
            <div className="order-modal-wrapper">
              {this.props.orderStage === 'search' ? <SearchCarModal /> : null}
              {this.props.orderStage === 'notfound' ? <NotFoundModal /> : null}
              {this.props.orderStage === 'carfound' ? <CarFoundModal /> : null}
              {this.props.orderStage === 'cararrived' ? <CarArrivedModal /> : null}
              {this.props.orderStage === 'onway' ? <CarOnWayModal /> : null}
            </div>
          </div>
        ) : null }
      </div>
    </div>
    <NotificationContainer />
    </>)
  }
}

const withData = inject(stores => ({
  orderStage: stores.OrderStore.orderStage,
  errorMsg: stores.NotificationsStore.errorMsg,
  succesMsg: stores.NotificationsStore.succesMsg,
}))

export default withData(LoginPage);
